export default __webpack_public_path__ + "static/media/investment-acquisition-header.e039ce60.svg";